import { useState, useEffect } from 'react';
import { persistStorageService } from '@/features/auth/persist-storage';

const getStoredWidgetRole = () => {
  const role = persistStorageService.getPersistItem<string>({
    name: 'widget_user_role',
  });
  return role ? role.toLowerCase() : null;
};

/**
 * Hook to get the user role from widget configuration
 * This is used for role-based UI in the widget context
 *
 * @returns The user role string ("employee", "manager", "admin") or null
 */
export const useWidgetUserRole = () => {
  const [userRole, setUserRole] = useState<string | null>(getStoredWidgetRole);

  useEffect(() => {
    setUserRole(getStoredWidgetRole());
  }, []);

  return userRole;
};

/**
 * Helper to check if user has a specific role
 */
export const useHasRole = (role: string) => {
  const userRole = useWidgetUserRole();
  return userRole === role.toLowerCase();
};

/**
 * Helper to check if user is admin
 */
export const useIsAdmin = () => {
  return useHasRole('admin');
};

/**
 * Helper to check if user is manager or admin
 */
export const useIsManagerOrAdmin = () => {
  const userRole = useWidgetUserRole();
  return userRole === 'manager' || userRole === 'admin';
};
